/*
Generated time: May 22, 2025 08:22
This file was created by the app developer. Feel free to contact the original developer with any questions. It was minified (compressed) by AVADA. AVADA do NOT own this script.
*/
document.addEventListener('DOMContentLoaded', function () {
  let n
  function r() {
    ;(e = 1), (t = 9)
    var t = Math.floor(Math.random() * (t - e)) + e,
      e = new Date()
    n = e.setHours(e.getHours() + t)
  }
  let t
  r(),
    t && clearInterval(t),
    (t = setInterval(function () {
      var t = (() => {
        var t = new Date()
        let e = new Date(n).getTime() - t.getTime()
        e < 0 && (r(), (e = 0))
        var t = Math.floor((e / 36e5) % 24),
          o = Math.floor((e / 6e4) % 60),
          s = Math.floor((e / 1e3) % 60)
        return { hour: 10 <= t ? t : '0' + t, minute: 10 <= o ? o : '0' + o, second: 10 <= s ? s : '0' + s }
      })()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(t.hour),
        $('.sp_top_cut_down .sp_left_view .sp_minute').html(t.minute),
        $('.sp_top_cut_down .sp_left_view .sp_second').html(t.second)
    }, 1e3))
  let e = [
      'https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20250228-p2.png',
      'https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20250228-p1.png',
      'https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20250228-b1.png',
      'https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20250228-b2.png',
      'https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20250228-b3.png',
      'https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20250228-b4.png',
      'https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20250228-b5.png',
      'https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20250228-c1.png',
      'https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20250228-c2.png',
      'https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20250228-c3.png',
      'https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20250228-c4.png',
      'https://cdn.shopify.com/s/files/1/0702/8074/1151/files/20250228-c5.png'
    ],
    o = new Swiper('#swiper-p1', {
      on: {
        slideChange: function (t) {
          $('#sp-color .sp-option').eq(t.activeIndex).addClass('active').siblings().removeClass('active')
        }
      },
      speed: 1,
      spaceBetween: 20
    })
  // new Swiper('#sp-swiper2', {
  //   autoplay: !0,
  //   autoplay: { disableOnInteraction: !1 },
  //   spaceBetween: 0,
  //   slidesPerView: 'auto',
  //   centeredSlides: !0,
  //   loop: !0,
  //   pagination: { el: '.sp-pagination1', clickable: !0 }
  // }),
    $(function () {
      $('#root').css('zoom', 'normal')
      var t,
        e = document.body.clientWidth / 1080
      $('#root').css('zoom', e),
        window.addEventListener('resize', function () {
          t && clearTimeout(t),
            (t = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              var t = document.body.clientWidth / 1080
              $('#root').css('zoom', t)
            }, 100))
        })
    })
  {
    var s = document.querySelectorAll('.lazy-load')
    let o = new IntersectionObserver(
      function (t, e) {
        t.forEach(function (t) {
          var e
          t.isIntersecting && ((e = (t = t.target).getAttribute('data-src')), (t.src = e), o.unobserve(t))
        })
      },
      { rootMargin: '0px 0px 1300px 0px', threshold: 0 }
    )
    s.forEach(function (t) {
      o.observe(t)
    })
  }
  ;(s = e),
    Array.isArray(s[0])
      ? s.forEach(t => {
          t.forEach(t => {
            new Image().src = t
          })
        })
      : s.forEach(t => {
          new Image().src = t
        }),
    document.querySelectorAll('a[href^="#shopping"]').forEach(function (t) {
      t.addEventListener('click', function (t) {
        t.preventDefault()
        t = document.getElementById('shopping').offsetTop
        window.scroll({ top: t * $('div#root').css('zoom') - 255 * $('div#root').css('zoom'), behavior: 'smooth' })
      })
    })
  var s = navigator.userAgent || navigator.vendor || window.opera,
    c = /android/i.test(s),
    a = /iPad|iPhone|iPod/.test(s) && !window.MSStream,
    s = !c && !a && !/Iron/.test(s)
  c
    ? console.log('Android')
    : a
    ? console.log('iOS')
    : s
    ? console.log('PC')
    : $('.sp_system').css('letter-spacing', '-4px')
  let p = window.product
  function l() {
    let e = $('#sp-color div.active').attr('data-val')
    return p.filter(t => t.option1 == e)[0]
  }
  function d() {
    var t = $('#calcNumber').val(),
      e = ((l().price * t) / 100).toFixed(2),
      t = ((l().compare_at_price * t) / 100).toFixed(2),
      e = ($('#sp_price1').html(e), $('#sp_price2').html(t), 100 - Math.ceil((l().price / l().compare_at_price) * 100))
    $('.product-part .sp-row p').html(e + '% off')
  }
  function h(t) {
    60 < t
      ? ($('.product-part .sp-tip').show(), $('.product-part .btn-free').show())
      : ($('.product-part .sp-tip').hide(), $('.product-part .btn-free').hide())
  }
  console.log(p, 'prods'),
    $('.sp-btn-style').click(function () {
      var t = $('#calcNumber').val()
      window.location.href = '/cart/' + l().id + ':' + t
    }),
    $('.sp-reduce').click(function () {
      var t = $(this).siblings('input')[0],
        e = Number(t.value) - 1
      0 < e && ((t.value = e), d()), h($('#sp_price1').html())
    }),
    $('.sp-add').click(function () {
      var t = $(this).siblings('input')[0],
        e = Number(t.value) + 1
      ;(t.value = e), d(), h($('#sp_price1').html())
    }),
    $(function () {
      $('.sp-option').click(function () {
        $(this).siblings().removeClass('active'), $(this).addClass('active'), d()
        var t = $('#sp-color .sp-option.active').index()
        o.slideTo(t)
      }),
        $('.cart-btn').click(function () {
          $(this).children('img').addClass('on'),
            $('.sp-header-top .sp-cart .num').show(),
            setTimeout(function () {
              $('.cart-btn').children('img').removeClass('on')
            }, 500),
            $('.sp-header-top .sp-cart').addClass('on'),
            setTimeout(function () {
              $('.sp-header-top .sp-cart').removeClass('on')
            }, 500)
        }),
        0 < window.cartCount && $('#cardNum').removeClass('sp-gray')
      $('.product-part .cart-btn').click(function () {
        var t = { id: l().id, quantity: $('#calcNumber').val() },
          t =
            ($.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: t,
              success: function () {
                $.getJSON(window.Shopify.routes.root + 'cart.js', function (t) {
                  $('#cardNum').html(t.item_count), $('#cardNum').removeClass('sp-gray')
                })
              },
              dataType: 'json'
            }),
            $('.product-part .swiper-slide-active .sp-img')),
          e = t[0].cloneNode(!0),
          e =
            (e.classList.add('sp_clone'),
            $('.product-part').append(e),
            $('.sp_clone').css({
              width: t[0].width,
              height: t[0].height,
              position: 'fixed',
              top: t[0].offsetTop,
              left: t.offset().left,
              'z-index': '99'
            }),
            $('.sp-cart'))
        $('.sp_clone').animate(
          {
            top: e[0].offsetTop + e.height() / 2 + $('.time-part').height(),
            left: e[0].offsetLeft + e.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4
          },
          500,
          'linear',
          function () {
            $(this).animate({ width: 0, height: 0, opacity: 0 }, 0, function () {
              $(this).detach()
            })
          }
        )
      })
    })
  var f = 180 / Math.sin(Math.PI / 16)
  carouselSwiper = new Swiper('#carousel .swiper', {
    watchSlidesProgress: !0,
    slidesPerView: 'auto',
    centeredSlides: !1,
    loop: !0,
    loopedSlides: 3,
    grabCursor: !0,
    autoplay: { delay: 0, stopOnLastSlide: !1, disableOnInteraction: !1 },
    freeMode: !0,
    speed: 4e3,
    on: {
      progress: function (t, e) {
        for (i = 0; i < this.slides.length; i++) {
          var o = this.slides.eq(i),
            s = this.slides[i].progress,
            n = (s + 1.5) * (120 - (360 * Math.cos(0.125 * (s + 1.5) * Math.PI) * 1.1) / 3) + 'px',
            r = 22.5 * (s + 1.5),
            s = f - Math.cos(0.125 * (s + 1.5) * Math.PI) * f - 150 + 'px'
          o.transform('translateX(' + n + ') translateZ(' + s + ') rotateY(' + r + 'deg)')
        }
      },
      setTransition: function (t, e) {
        for (var o = 0; o < this.slides.length; o++) this.slides.eq(o).transition(e)
      }
    }
  })
})
